<template>
  <div>
    <div class="row">
      <div class="col-12">
        <card title="Update user details">
          <form @submit.prevent="updateUser">
            <label>Username</label>
            <fieldset>
              <div class="form-group">
                <input 
                  type="text"
                  class="form-control form-control-lg"
                  placeholder="name"
                  v-model="user.username"
                />
              </div>

              <div class="form-group">    
                <label>Email</label>
                <input 
                  type="email"
                  class="form-control form-control-lg"
                  placeholder="email"
                  v-model="user.email"
                />
              </div>

              <div class="form-group">
                <label>Password</label>
                <input 
                  type="password"
                  id="password-input"
                  class="form-control form-control-lg"
                  placeholder="password"
                  v-model="user.password"
                />
                <div class="show-password" @click="toggleShowPassword($event)">
                  <span :class="isPasswordShowing ? 'fa fa-eye' : 'fa fa-eye-slash'"></span>
                </div>
              </div>
            </fieldset>

            
            <fieldset v-if="isAdmin" class="form-group mt-4">
              <label>Grant Access</label>
              <ul class="user-access-list">
                <li>
                  <label for="assets"><input type="checkbox" id="assets" v-model="user.access" value="assets"> Assets</label>
                </li>
                <li>
                  <label for="pages"><input type="checkbox" id="pages" v-model="user.access" value="pages"> Pages</label>
                  <ul class="user-access-list">
                    <li>
                      <label for="pagesCreate"><input type="checkbox" id="pagesCreate" v-model="user.access" value="pagesCreate"> Create Pages</label>
                    </li>
                    <li>
                      <label for="pagesEdit"><input type="checkbox" id="pagesEdit" v-model="user.access" value="pagesEdit"> Edit Pages</label>
                    </li>
                    <li>
                      <label for="pagesDelete"><input type="checkbox" id="pagesDelete" v-model="user.access" value="pagesDelete"> Delete Pages</label>
                    </li>
                  </ul>
                </li>
                <li>
                  <label for="navigation"><input type="checkbox" id="navigation" v-model="user.access" value="navigation"> Navigation</label>
                </li>
                <li>
                  <label for="live"><input type="checkbox" id="live" v-model="user.access" value="live"> Live</label>
                  <ul class="user-access-list">
                    <li>
                      <label>Property Fields</label>
                      <ul class="user-access-list">
                        <li>
                          <label for="propertyBuilder"><input type="checkbox" id="propertyBuilder" v-model="user.access" value="propertyBuilder"> Builder</label>
                        </li>
                        <li>
                          <label for="propertyDesign"><input type="checkbox" id="propertyDesign" v-model="user.access" value="propertyDesign"> Design</label>
                        </li>
                        <!-- <li>
                          <label for="propertyDraft"><input type="checkbox" id="propertyDraft" v-model="user.access" value="propertyDraft"> Draft</label>
                        </li> -->
                        <!-- <li>
                          <label for="propertyFloorPlan"><input type="checkbox" id="propertyFloorPlan" v-model="user.access" value="propertyFloorPlan"> Floor Plan</label>
                        </li> -->
                        <li>
                          <label for="propertyImages"><input type="checkbox" id="propertyImages" v-model="user.access" value="propertyImages"> Images</label>
                        </li>
                        <li>
                          <label for="propertyLabel"><input type="checkbox" id="propertyLabel" v-model="user.access" value="propertyLabel"> Label</label>
                        </li>
                        <li>
                          <label for="propertyLandareaMsq"><input type="checkbox" id="propertyLandareaMsq" v-model="user.access" value="propertyLandareaMsq"> Landarea msq</label>
                        </li>
                        <li>
                          <label for="propertyLandPrice"><input type="checkbox" id="propertyLandPrice" v-model="user.access" value="propertyLandPrice"> Land Price</label>
                        </li>
                        <li>
                          <label for="propertyLivingMsq"><input type="checkbox" id="propertyLivingMsq" v-model="user.access" value="propertyLivingMsq"> Living msq</label>
                        </li>
                        <!-- <li>
                          <label for="propertyMarker"><input type="checkbox" id="propertyMarker" v-model="user.access" value="propertyMarker"> Positional Marker</label>
                        </li> -->
                        <li>
                          <label for="propertyModelIds"><input type="checkbox" id="propertyModelIds" v-model="user.access" value="propertyModelIds"> Associated Model Ids</label>
                        </li>
                        <li>
                          <label for="propertyMsq"><input type="checkbox" id="propertyMsq" v-model="user.access" value="propertyMsq"> Total Msq</label>
                        </li>
                        <li>
                          <label for="propertyOutdoorMsq"><input type="checkbox" id="propertyOutdoorMsq" v-model="user.access" value="propertyOutdoorMsq"> Outdoor Msq</label>
                        </li>
                        <li>
                          <label for="propertyPrice"><input type="checkbox" id="propertyPrice" v-model="user.access" value="propertyPrice"> Price</label>
                        </li>
                        <li>
                          <label for="propertyStatus"><input type="checkbox" id="propertyStatus" v-model="user.access" value="propertyStatus"> Status</label>
                        </li>
                        <li>
                          <label for="propertyTotalPackagePrice"><input type="checkbox" id="propertyTotalPackagePrice" v-model="user.access" value="propertyTotalPackagePrice"> Total Package Price</label>
                        </li>
                        <!-- <li>
                          <label for="propertyView"><input type="checkbox" id="propertyView" v-model="user.access" value="propertyView"> Aspect</label>
                        </li> -->
                      </ul>
                    </li>
                    <br>
                    <li>
                      <label>Property Model Fields</label>
                      <ul class="user-access-list">
                        <li>
                          <label for="propertyModelAspect"><input type="checkbox" id="propertyModelAspect" v-model="user.access" value="propertyModelAspect"> Aspect</label>
                        </li>
                        <li>
                          <label for="propertyModelBaths"><input type="checkbox" id="propertyModelBaths" v-model="user.access" value="propertyModelBaths"> Baths</label>
                        </li>
                        <li>
                          <label for="propertyModelBeds"><input type="checkbox" id="propertyModelBeds" v-model="user.access" value="propertyModelBeds"> Beds</label>
                        </li>
                        <!-- <li>
                          <label for="propertyModelBuilder"><input type="checkbox" id="propertyModelBuilder" v-model="user.access" value="propertyModelBuilder"> Builder</label>
                        </li> -->
                        <li>
                          <label for="propertyModelCars"><input type="checkbox" id="propertyModelCars" v-model="user.access" value="propertyModelCars"> Cars</label>
                        </li>
                        <li>
                          <label for="propertyModelFeatures"><input type="checkbox" id="propertyModelFeatures" v-model="user.access" value="propertyModelFeatures"> Features</label>
                        </li>
                        <li>
                          <label for="propertyModelFloorPlan"><input type="checkbox" id="propertyModelFloorPlan" v-model="user.access" value="propertyModelFloorPlan"> Floor Plan</label>
                        </li>
                        <li>
                          <label for="propertyModelImages"><input type="checkbox" id="propertyModelImages" v-model="user.access" value="propertyModelImages"> Images</label>
                        </li>
                        <li>
                          <label for="propertyModelLabel"><input type="checkbox" id="propertyModelLabel" v-model="user.access" value="propertyModelLabel"> Label</label>
                        </li>
                        <li>
                          <label for="propertyModelLivingMsq"><input type="checkbox" id="propertyModelLivingMsq" v-model="user.access" value="propertyModelLivingMsq"> Living Msq</label>
                        </li>
                        <li>
                          <label for="propertyModelMsq"><input type="checkbox" id="propertyModelMsq" v-model="user.access" value="propertyModelMsq"> Total Msq</label>
                        </li>
                        <li>
                          <label for="propertyModelOutdoorMsq"><input type="checkbox" id="propertyModelOutdoorMsq" v-model="user.access" value="propertyModelOutdoorMsq"> Outdoor Msq</label>
                        </li>
                        <li>
                          <label for="propertyModelPrice"><input type="checkbox" id="propertyModelPrice" v-model="user.access" value="propertyModelPrice"> Price</label>
                        </li>
                        <li>
                          <label for="propertyModelType"><input type="checkbox" id="propertyModelType" v-model="user.access" value="propertyModelType"> Type</label>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
                <li>
                  <label for="settings"><input type="checkbox" id="settings" v-model="user.access" value="settings"> Settings</label>
                </li>
                <li>
                  <label for="users"><input type="checkbox" id="users" v-model="user.access" value="users"> Create / Update Users</label>
                </li>
              </ul>
            </fieldset>

            <input 
              type="submit"
              class="btn btn-primary mb-2"
              value="Update"
            />
          </form>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { USER_EDIT, FETCH_USER_BY_ID } from '@/store/actions.type'

export default {

  data() {
    return {
      isPasswordShowing: false,
      user: {}
    }
  },

  computed: {
    isAdmin () {
      return this.$store.getters.currentUser.isAdmin
    }
  },

  beforeMount() {
    const userId = this.$route.params.userId
    this.$store.dispatch(FETCH_USER_BY_ID, userId).then(res => {
      this.user = res.user
    })
  },

  methods: {
    updateUser() {
      this.$store.dispatch(USER_EDIT, this.user).then(() => {
        this.$notify({
          message: 'User updated',
          horizontalAlign: "center",
          verticalAlign: "top",
          type: "success"
        })

        window.location.reload()
      }).catch(() => {
        this.$notify({
          message: 'An error occured',
          horizontalAlign: "center",
          verticalAlign: "top",
          type: "danger"
        })
      })
    },

    toggleShowPassword(event) {
      let passwordInput = document.querySelector('#password-input')
      
      this.isPasswordShowing = !this.isPasswordShowing
      passwordInput.type = this.isPasswordShowing ? 'text' : 'password'
    }
  }
}
</script>
<style lang="scss" scoped>

.form-group {
  position: relative;
}

.show-password {
  bottom: 0;
  cursor: pointer;
  position: absolute;
  right: 15px;
  transform: translateY(-50%);
}

.user-access-list {
  list-style: none;
  padding: 0 16px;

  li {
    label {
      font-size: 14px;
      user-select: none;
    }
  }
}

.user-list {
  list-style: none;
  padding: 0;

  > :nth-child(even) {
    background: #f1f1f1;
  }

  .user {
    align-items: center;
    display: flex;
    padding: 6px 16px;

    &__username {
      font-size: 16px;
    }

    &__email {
      font-size: 14px;
      margin-left: .75em;
      opacity: .7;
    }

    &__btn {
      margin-left: auto;
    }
  }
}
</style>
